import React, { useEffect, useState } from "react";
import Ifern4pService from "../../../service/ifern4p/ifern4p";
import Table from "react-bootstrap/Table";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import moment from "moment";
//service
import AppInfoservice from "../../../service/common/Appinfo";

//style
import { Row, Col } from "react-bootstrap";

export class ComponentToPrint extends React.PureComponent {
  constructor(props) {
    super(props);
    this.service = new Ifern4pService();
    console.log("pronhggggh", props);
    const current = new Date();

    const date = `${current.getDate()}/${
      current.getMonth() + 1
    }/${current.getFullYear()} , ${current.getHours()}:${current.getMinutes()}`;
    // const time = current.getHours() + ':' + current.getMinutes();

    this.state = {
      earnings: {},
      loading: true,
      date: date,
    };
  }

  exportDatas(type) {
    let keys = this.props.data.filterValues
      .map((key, idx) => {
        return "categories[" + idx + "]=" + key.value;
      })
      .join("&");
    console.log("enterde===");

    console.log("selectedddtabbbb", this.props.data.selectedTab);
    if (this.props.data.selectedTab === "fourpcodelisthistory") {
      this.service
        .exportDataHistory(
          this.props.data.startDate,
          this.props.data.endDate,
          keys,
          type
        )
        .then((res) => {
          if (res.status) {
            this.setState((prevState) => ({
              ...prevState,
              loading: false,
              earnings: res.data.result,
            }));
          } else {
            this.setState((prevState) => ({
              ...prevState,
              loading: true,
            }));
          }
        });

      console.log("earnings", this.state.earnings);
    } else {
      this.service
        .exportData(
          this.props.data.startDate,
          this.props.data.endDate,
          keys,
          type
        )
        .then((res) => {
          if (res.status) {
            this.setState((prevState) => ({
              ...prevState,
              loading: false,
              earnings: res.data.result,
            }));
          } else {
            this.setState((prevState) => ({
              ...prevState,
              loading: true,
            }));
          }
        });
    }
  }

  componentDidUpdate(prevProps) {
    console.log("prevpropss", prevProps);
    if (
      this.props.data.filterValues != prevProps.data.filterValues ||
      this.props.data.startDate != prevProps.data.startDate ||
      this.props.data.endDate != prevProps.data.endDate ||
      this.props.data.selectedTab != prevProps.data.selectedTab
    ) {
      this.exportDatas("print");
    }
  }
  componentDidMount() {
    this.exportDatas("print");
  }

  render() {
    return (
      <div style={{ padding: 60 }}>
        <Row>
          <Col>{this.state.date}</Col>
          <Col>
            <h5 style={{ textAlign: "center" }}>User Earnigs Report</h5>
          </Col>
        </Row>

        <div ref={this.ref}>
          <Row style={{ marginBottom: 50 }}>
            <Col span={8}>
              <img
                src={this.props.company.logo}
                alt="Logo"
                style={{ width: "10%" }}
              />
              <div>COMPANY NAME : {this.props.company.comapny_name}</div>
              <div>COMPANY ADDRESS : {this.props.company.company_address}</div>
              <div>TELEPHONE : {this.props.company.phone}</div>
              <div>EMAIL : {this.props.company.email}</div>
            </Col>
          </Row>

          {!this.state.loading && this.state.earnings.length > 0 && (
            <Table striped hover>
              {this.props.data.selectedTab === "fourpcodelisthistory" ? (
                <>
                  <thead>
                    <tr>
                      <td>No</td>
                      <td>{this.props.t("Common.ExpirationDate")}</td>
                      <th>{this.props.t("Common.Pairvalue")}</th>
                      <th>{this.props.t("Common.accesscode")}</th>
                      <th>{this.props.t("Common.SecurityCode")}</th>
                      <th>{this.props.t("Common.Status")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.earnings.map((obj, index) => {
                      console.log("printdataa", obj);
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{obj.expiration_date}</td>
                          <td>{obj.pair_value}</td>
                          <td>{obj.access_code}</td>
                          <td>{obj.security_code}</td>
                          <td>{obj.status}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </>
              ) : this.props.data.selectedTab === "activatedproductlist" ? (
                <>
                  <thead>
                    <tr>
                      <th>no</th>
                      <th>{this.props.t("Common.username")}</th>
                      <th>{this.props.t("Common.date")}</th>
                      <th>{this.props.t("Common.accesscode")}</th>
                      <th>{this.props.t("Common.securitycode")}</th>
                      <th>{this.props.t("Common.productname")}</th>
                      <th>{this.props.t("Common.pairvalue")}</th>
                      <th>{this.props.t("Common.price")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.earnings.map((obj, index) => {
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{obj.username}</td>
                          <td>{obj.date}</td>
                          <td>{obj.access_code}</td>
                          <td>{obj.security_code}</td>
                          <td>{obj.product_name}</td>
                          <td>{obj.pair_value}</td>
                          <td>
                            {" "}
                            {this.props.Currency.currentCurr}
                            {(
                              parseFloat(obj.price) * this.props.Currency.value
                            ).toFixed(this.props.Currency.precision)}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </>
              ) : (
                ""
              )}
            </Table>
          )}
        </div>
      </div>
    );
  }
}

const TransactionListingPrintView = React.forwardRef((props, ref) => {
  console.log("print", props);
  const Currency = useSelector((state) => state.curr);
  const { t } = useTranslation();

  const [companyDetails, setCompanyDetails] = useState({});

  const service = new AppInfoservice();

  useEffect(() => {
    service.Appinfo().then((res) => {
      if (res.status) {
        setCompanyDetails((prevState) => ({
          ...prevState,
          exportData: res.data.company_info.login_logo,
          comapny_name: res.data.company_info.company_name,
          company_address: res.data.company_info.company_address,
          phone: res.data.company_info.phone,
          email: res.data.company_info.email,
        }));
      }
    });
  }, []);
  return (
    <ComponentToPrint
      ref={ref}
      data={props}
      company={companyDetails}
      Currency={Currency}
      t={t}
    />
  );
});
export default TransactionListingPrintView;
